import { Link, useParams } from "react-router-dom";
import { useCustomerOrder } from "../../api/customerOrders";
import { useInvoice } from "../../api/invoices";
import "../../styles/commercial.css";
import BoqWorkspace from "../boq/BoqWorkspace";
import { OrderView as CustomerOrderView } from "../customer-orders/CustomerOrdersPage";
import { InvoiceView } from "../invoices/InvoicesPage";
import OrderWorkspace from "../purchase-orders/OrderWorkspace";

type Kind = "po" | "boq" | "customer" | "invoice";

/** One document, on its own, for a link that names it rather than its job --
 * a PDF's neighbour in an email, a row in the tracker, a bookmark made before
 * the five registers became one screen. The work happens on the commercial
 * screen, which this says and links to; every link inside the document goes
 * to its job rather than to another page like this one. */
export default function DocumentPage({ kind }: { kind: Kind }) {
  const { id } = useParams();
  const documentId = Number(id);
  return (
    <div className="quotations-page cm-standalone">
      <p className="cm-doc-note">
        <Link to="/commercial">← Commercial</Link> · this document is worked on its job, with everything else the job
        produced.
      </p>
      <section className="cm-doc">
        {kind === "po" ? <OrderWorkspace id={documentId} /> : null}
        {kind === "boq" ? <BoqWorkspace id={documentId} /> : null}
        {kind === "customer" ? <CustomerOrderDocument id={documentId} /> : null}
        {kind === "invoice" ? <InvoiceDocument id={documentId} /> : null}
      </section>
    </div>
  );
}

function CustomerOrderDocument({ id }: { id: number }) {
  const order = useCustomerOrder(id);
  if (order.isPending) {
    return <p className="empty-state">Loading the order…</p>;
  }
  if (order.isError) {
    return <p className="notice bad">{order.error.message}</p>;
  }
  return <CustomerOrderView order={order.data} />;
}

function InvoiceDocument({ id }: { id: number }) {
  const invoice = useInvoice(id);
  if (invoice.isPending) {
    return <p className="empty-state">Loading the invoice…</p>;
  }
  if (invoice.isError) {
    return <p className="notice bad">{invoice.error.message}</p>;
  }
  return <InvoiceView invoice={invoice.data} />;
}
